/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as Pdf2IndexImport } from './routes/pdf2.index'
import { Route as CompanyIndexImport } from './routes/company/index'
import { Route as CompanyLayoutImport } from './routes/company/_layout'
import { Route as pharmaLayoutImport } from './routes/(pharma)/_layout'
import { Route as inventoryBranchIndexImport } from './routes/(inventory)/branch/index'
import { Route as authSelectAccessIndexImport } from './routes/(auth)/select-access/index'
import { Route as authResetPasswordIndexImport } from './routes/(auth)/reset-password/index'
import { Route as authLoginIndexImport } from './routes/(auth)/login/index'
import { Route as authForgotPasswordIndexImport } from './routes/(auth)/forgot-password/index'
import { Route as inventoryBranchLayoutImport } from './routes/(inventory)/branch/_layout'
import { Route as CompanyLayoutSettingsIndexImport } from './routes/company/_layout/settings/index'
import { Route as CompanyLayoutReportsIndexImport } from './routes/company/_layout/reports/index'
import { Route as CompanyLayoutInventoryIndexImport } from './routes/company/_layout/inventory/index'
import { Route as CompanyLayoutHomeIndexImport } from './routes/company/_layout/home/index'
import { Route as CompanyLayoutDashboardIndexImport } from './routes/company/_layout/dashboard/index'
import { Route as CompanyLayoutAccountsIndexImport } from './routes/company/_layout/accounts/index'
import { Route as pharmaLayoutSuppliersIndexImport } from './routes/(pharma)/_layout/suppliers/index'
import { Route as pharmaLayoutStockTakingIndexImport } from './routes/(pharma)/_layout/stock-taking/index'
import { Route as pharmaLayoutSettingsIndexImport } from './routes/(pharma)/_layout/settings/index'
import { Route as pharmaLayoutSalesIndexImport } from './routes/(pharma)/_layout/sales/index'
import { Route as pharmaLayoutPatientsIndexImport } from './routes/(pharma)/_layout/patients/index'
import { Route as pharmaLayoutOverviewIndexImport } from './routes/(pharma)/_layout/overview/index'
import { Route as pharmaLayoutOffersIndexImport } from './routes/(pharma)/_layout/offers/index'
import { Route as pharmaLayoutInvoicingIndexImport } from './routes/(pharma)/_layout/invoicing/index'
import { Route as pharmaLayoutInventoryIndexImport } from './routes/(pharma)/_layout/inventory/index'
import { Route as pharmaLayoutHomeIndexImport } from './routes/(pharma)/_layout/home/index'
import { Route as pharmaLayoutAccountsIndexImport } from './routes/(pharma)/_layout/accounts/index'
import { Route as pharmaLayoutReceiptSaleIdImport } from './routes/(pharma)/_layout/receipt/$saleId'
import { Route as CompanyLayoutInventoryTransferStockIndexImport } from './routes/company/_layout/inventory/transfer-stock/index'
import { Route as CompanyLayoutInventoryTransferHistoryIndexImport } from './routes/company/_layout/inventory/transfer-history/index'
import { Route as CompanyLayoutInventoryPendingAcceptanceInventoryIndexImport } from './routes/company/_layout/inventory/pending-acceptance-inventory/index'
import { Route as CompanyLayoutInventoryNonMedicalMasterIndexImport } from './routes/company/_layout/inventory/non-medical-master/index'
import { Route as CompanyLayoutInventoryMedicalMasterIndexImport } from './routes/company/_layout/inventory/medical-master/index'
import { Route as CompanyLayoutInventoryAvailableInventoryIndexImport } from './routes/company/_layout/inventory/available-inventory/index'
import { Route as pharmaLayoutSuppliersSupplierIdIndexImport } from './routes/(pharma)/_layout/suppliers/$supplierId/index'
import { Route as pharmaLayoutReportsVoidSalesIndexImport } from './routes/(pharma)/_layout/reports/void-sales/index'
import { Route as pharmaLayoutReportsSupplierProfitabilityIndexImport } from './routes/(pharma)/_layout/reports/supplier-profitability/index'
import { Route as pharmaLayoutReportsShiftHistoryIndexImport } from './routes/(pharma)/_layout/reports/shift-history/index'
import { Route as pharmaLayoutReportsSalesSummaryIndexImport } from './routes/(pharma)/_layout/reports/sales-summary/index'
import { Route as pharmaLayoutReportsSalesPerItemIndexImport } from './routes/(pharma)/_layout/reports/sales-per-item/index'
import { Route as pharmaLayoutReportsPurchaseReturnsListIndexImport } from './routes/(pharma)/_layout/reports/purchase-returns-list/index'
import { Route as pharmaLayoutReportsPurchaseRequestsListIndexImport } from './routes/(pharma)/_layout/reports/purchase-requests-list/index'
import { Route as pharmaLayoutReportsPurchaseOrderListIndexImport } from './routes/(pharma)/_layout/reports/purchase-order-list/index'
import { Route as pharmaLayoutReportsPurchaseInvoiceListIndexImport } from './routes/(pharma)/_layout/reports/purchase-invoice-list/index'
import { Route as pharmaLayoutReportsProductProfitablityIndexImport } from './routes/(pharma)/_layout/reports/product-profitablity/index'
import { Route as pharmaLayoutReportsPlReportIndexImport } from './routes/(pharma)/_layout/reports/pl-report/index'
import { Route as pharmaLayoutReportsOutOfStockIndexImport } from './routes/(pharma)/_layout/reports/out-of-stock/index'
import { Route as pharmaLayoutReportsExpiryListIndexImport } from './routes/(pharma)/_layout/reports/expiry-list/index'
import { Route as pharmaLayoutReportsCustomerWiseRevenueIndexImport } from './routes/(pharma)/_layout/reports/customer-wise-revenue/index'
import { Route as pharmaLayoutOverviewSaleshistoryIndexImport } from './routes/(pharma)/_layout/overview/sales_history/index'
import { Route as pharmaLayoutInventoryTransferStockIndexImport } from './routes/(pharma)/_layout/inventory/transfer-stock/index'
import { Route as pharmaLayoutInventoryTransferHistoryIndexImport } from './routes/(pharma)/_layout/inventory/transfer-history/index'
import { Route as pharmaLayoutInventoryPendingAcceptanceInventoryIndexImport } from './routes/(pharma)/_layout/inventory/pending-acceptance-inventory/index'
import { Route as pharmaLayoutInventoryNonMedicalMasterIndexImport } from './routes/(pharma)/_layout/inventory/non-medical-master/index'
import { Route as pharmaLayoutInventoryMedicalMasterIndexImport } from './routes/(pharma)/_layout/inventory/medical-master/index'
import { Route as pharmaLayoutInventoryCreatePurchaseOrderIndexImport } from './routes/(pharma)/_layout/inventory/create-purchase-order/index'
import { Route as pharmaLayoutInventoryAvailableInventoryIndexImport } from './routes/(pharma)/_layout/inventory/available-inventory/index'
import { Route as pharmaLayoutInventoryAddStockIndexImport } from './routes/(pharma)/_layout/inventory/add-stock/index'
import { Route as pharmaLayoutAccountsRevenueIndexImport } from './routes/(pharma)/_layout/accounts/revenue/index'
import { Route as pharmaLayoutAccountsProfitLossIndexImport } from './routes/(pharma)/_layout/accounts/profit-loss/index'
import { Route as pharmaLayoutAccountsPaymentMethodBreakdownIndexImport } from './routes/(pharma)/_layout/accounts/payment-method-breakdown/index'
import { Route as pharmaLayoutAccountsCostOfGoodsIndexImport } from './routes/(pharma)/_layout/accounts/cost-of-goods/index'
import { Route as inventoryBranchLayoutSettingsIndexImport } from './routes/(inventory)/branch/_layout/settings/index'
import { Route as inventoryBranchLayoutSaleshistoryIndexImport } from './routes/(inventory)/branch/_layout/sales_history/index'
import { Route as inventoryBranchLayoutReportsIndexImport } from './routes/(inventory)/branch/_layout/reports/index'
import { Route as inventoryBranchLayoutPurchaseOrdersIndexImport } from './routes/(inventory)/branch/_layout/purchase-orders/index'
import { Route as inventoryBranchLayoutPurchaseInvoicesIndexImport } from './routes/(inventory)/branch/_layout/purchase-invoices/index'
import { Route as inventoryBranchLayoutInventoryIndexImport } from './routes/(inventory)/branch/_layout/inventory/index'
import { Route as inventoryBranchLayoutDashboardIndexImport } from './routes/(inventory)/branch/_layout/dashboard/index'
import { Route as inventoryBranchLayoutAutomationsIndexImport } from './routes/(inventory)/branch/_layout/automations/index'
import { Route as inventoryBranchLayoutAccountsIndexImport } from './routes/(inventory)/branch/_layout/accounts/index'
import { Route as pharmaLayoutSuppliersSupplierIdSupplierCreditNotesIndexImport } from './routes/(pharma)/_layout/suppliers/$supplierId/supplier-credit-notes/index'
import { Route as pharmaLayoutSuppliersSupplierIdMakePaymentIndexImport } from './routes/(pharma)/_layout/suppliers/$supplierId/make-payment/index'
import { Route as pharmaLayoutPatientsPatientInfoPatientIdIndexImport } from './routes/(pharma)/_layout/patients/patient-info/$patientId/index'
import { Route as pharmaLayoutOverviewSaleshistorySaleIdIndexImport } from './routes/(pharma)/_layout/overview/sales_history/$saleId/index'
import { Route as pharmaLayoutInventoryPurchaseRequestIdIndexImport } from './routes/(pharma)/_layout/inventory/purchase-request/$id/index'
import { Route as pharmaLayoutInventoryPurchaseOrderIdIndexImport } from './routes/(pharma)/_layout/inventory/purchase-order/$id/index'
import { Route as pharmaLayoutInventoryPurchaseInvoiceCreateIndexImport } from './routes/(pharma)/_layout/inventory/purchase-invoice/create/index'
import { Route as pharmaLayoutInventoryPurchaseInvoiceIdIndexImport } from './routes/(pharma)/_layout/inventory/purchase-invoice/$id/index'
import { Route as inventoryBranchLayoutReportsSupplierProfitabilityIndexImport } from './routes/(inventory)/branch/_layout/reports/supplier-profitability/index'
import { Route as inventoryBranchLayoutReportsSlowMovingItemsIndexImport } from './routes/(inventory)/branch/_layout/reports/slow-moving-items/index'
import { Route as inventoryBranchLayoutReportsShiftHistoryIndexImport } from './routes/(inventory)/branch/_layout/reports/shift-history/index'
import { Route as inventoryBranchLayoutReportsSalesSummaryIndexImport } from './routes/(inventory)/branch/_layout/reports/sales-summary/index'
import { Route as inventoryBranchLayoutReportsSalesPerItemIndexImport } from './routes/(inventory)/branch/_layout/reports/sales-per-item/index'
import { Route as inventoryBranchLayoutReportsProductProfitablityIndexImport } from './routes/(inventory)/branch/_layout/reports/product-profitablity/index'
import { Route as inventoryBranchLayoutReportsPlReportIndexImport } from './routes/(inventory)/branch/_layout/reports/pl-report/index'
import { Route as inventoryBranchLayoutReportsOutOfStockIndexImport } from './routes/(inventory)/branch/_layout/reports/out-of-stock/index'
import { Route as inventoryBranchLayoutReportsItemsReorderReportIndexImport } from './routes/(inventory)/branch/_layout/reports/items-reorder-report/index'
import { Route as inventoryBranchLayoutReportsItemSalesVelocityIndexImport } from './routes/(inventory)/branch/_layout/reports/item-sales-velocity/index'
import { Route as inventoryBranchLayoutReportsFastMovingItemsIndexImport } from './routes/(inventory)/branch/_layout/reports/fast-moving-items/index'
import { Route as inventoryBranchLayoutReportsExpiryListIndexImport } from './routes/(inventory)/branch/_layout/reports/expiry-list/index'
import { Route as inventoryBranchLayoutReportsCustomerWiseRevenueIndexImport } from './routes/(inventory)/branch/_layout/reports/customer-wise-revenue/index'
import { Route as inventoryBranchLayoutPurchaseOrdersCreateIndexImport } from './routes/(inventory)/branch/_layout/purchase-orders/create/index'
import { Route as inventoryBranchLayoutPurchaseOrdersIdIndexImport } from './routes/(inventory)/branch/_layout/purchase-orders/$id/index'
import { Route as inventoryBranchLayoutPurchaseInvoicesCreateIndexImport } from './routes/(inventory)/branch/_layout/purchase-invoices/create/index'
import { Route as inventoryBranchLayoutPurchaseInvoicesIdIndexImport } from './routes/(inventory)/branch/_layout/purchase-invoices/$id/index'
import { Route as inventoryBranchLayoutInventoryTransferStockIndexImport } from './routes/(inventory)/branch/_layout/inventory/transfer-stock/index'
import { Route as inventoryBranchLayoutInventoryTransferHistoryIndexImport } from './routes/(inventory)/branch/_layout/inventory/transfer-history/index'
import { Route as inventoryBranchLayoutInventoryPendingAcceptanceInventoryIndexImport } from './routes/(inventory)/branch/_layout/inventory/pending-acceptance-inventory/index'
import { Route as inventoryBranchLayoutInventoryNonMedicalMasterIndexImport } from './routes/(inventory)/branch/_layout/inventory/non-medical-master/index'
import { Route as inventoryBranchLayoutInventoryMedicalMasterIndexImport } from './routes/(inventory)/branch/_layout/inventory/medical-master/index'
import { Route as inventoryBranchLayoutInventoryAvailableInventoryIndexImport } from './routes/(inventory)/branch/_layout/inventory/available-inventory/index'
import { Route as inventoryBranchLayoutAutomationsIdIndexImport } from './routes/(inventory)/branch/_layout/automations/$id/index'
import { Route as inventoryBranchLayoutAccountsRevenueIndexImport } from './routes/(inventory)/branch/_layout/accounts/revenue/index'
import { Route as inventoryBranchLayoutAccountsProfitLossIndexImport } from './routes/(inventory)/branch/_layout/accounts/profit-loss/index'
import { Route as inventoryBranchLayoutAccountsPaymentMethodBreakdownIndexImport } from './routes/(inventory)/branch/_layout/accounts/payment-method-breakdown/index'
import { Route as inventoryBranchLayoutAccountsCostOfGoodsIndexImport } from './routes/(inventory)/branch/_layout/accounts/cost-of-goods/index'
import { Route as CompanyLayoutInventoryItemTypeItemIdImport } from './routes/company/_layout/inventory/item/$type.$itemId'
import { Route as pharmaLayoutInventoryItemTypeItemIdImport } from './routes/(pharma)/_layout/inventory/item/$type.$itemId'
import { Route as pharmaLayoutReportsShiftHistoryShiftSummaryShiftIdIndexImport } from './routes/(pharma)/_layout/reports/shift-history/shift-summary/$shiftId/index'
import { Route as pharmaLayoutInventoryPurchaseInvoiceIdPdfIndexImport } from './routes/(pharma)/_layout/inventory/purchase-invoice/$id/pdf/index'
import { Route as inventoryBranchLayoutPurchaseInvoicesIdPdfIndexImport } from './routes/(inventory)/branch/_layout/purchase-invoices/$id/pdf/index'
import { Route as inventoryBranchLayoutInventoryItemTypeItemIdImport } from './routes/(inventory)/branch/_layout/inventory/item/$type.$itemId'
import { Route as inventoryBranchLayoutReportsShiftHistoryShiftSummaryShiftIdIndexImport } from './routes/(inventory)/branch/_layout/reports/shift-history/shift-summary/$shiftId/index'

// Create Virtual Routes

const CompanyImport = createFileRoute('/company')()
const pharmaImport = createFileRoute('/(pharma)')()
const inventoryBranchImport = createFileRoute('/(inventory)/branch')()

// Create/Update Routes

const CompanyRoute = CompanyImport.update({
  path: '/company',
  getParentRoute: () => rootRoute,
} as any)

const pharmaRoute = pharmaImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const inventoryBranchRoute = inventoryBranchImport.update({
  path: '/branch',
  getParentRoute: () => rootRoute,
} as any)

const Pdf2IndexRoute = Pdf2IndexImport.update({
  path: '/pdf2/',
  getParentRoute: () => rootRoute,
} as any)

const CompanyIndexRoute = CompanyIndexImport.update({
  path: '/',
  getParentRoute: () => CompanyRoute,
} as any)

const CompanyLayoutRoute = CompanyLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => CompanyRoute,
} as any)

const pharmaLayoutRoute = pharmaLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => pharmaRoute,
} as any)

const inventoryBranchIndexRoute = inventoryBranchIndexImport.update({
  path: '/',
  getParentRoute: () => inventoryBranchRoute,
} as any)

const authSelectAccessIndexRoute = authSelectAccessIndexImport.update({
  path: '/select-access/',
  getParentRoute: () => rootRoute,
} as any)

const authResetPasswordIndexRoute = authResetPasswordIndexImport.update({
  path: '/reset-password/',
  getParentRoute: () => rootRoute,
} as any)

const authLoginIndexRoute = authLoginIndexImport.update({
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const authForgotPasswordIndexRoute = authForgotPasswordIndexImport.update({
  path: '/forgot-password/',
  getParentRoute: () => rootRoute,
} as any)

const inventoryBranchLayoutRoute = inventoryBranchLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => inventoryBranchRoute,
} as any)

const CompanyLayoutSettingsIndexRoute = CompanyLayoutSettingsIndexImport.update(
  {
    path: '/settings/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any,
)

const CompanyLayoutReportsIndexRoute = CompanyLayoutReportsIndexImport.update({
  path: '/reports/',
  getParentRoute: () => CompanyLayoutRoute,
} as any)

const CompanyLayoutInventoryIndexRoute =
  CompanyLayoutInventoryIndexImport.update({
    path: '/inventory/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any)

const CompanyLayoutHomeIndexRoute = CompanyLayoutHomeIndexImport.update({
  path: '/home/',
  getParentRoute: () => CompanyLayoutRoute,
} as any)

const CompanyLayoutDashboardIndexRoute =
  CompanyLayoutDashboardIndexImport.update({
    path: '/dashboard/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any)

const CompanyLayoutAccountsIndexRoute = CompanyLayoutAccountsIndexImport.update(
  {
    path: '/accounts/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any,
)

const pharmaLayoutSuppliersIndexRoute = pharmaLayoutSuppliersIndexImport.update(
  {
    path: '/suppliers/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any,
)

const pharmaLayoutStockTakingIndexRoute =
  pharmaLayoutStockTakingIndexImport.update({
    path: '/stock-taking/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutSettingsIndexRoute = pharmaLayoutSettingsIndexImport.update({
  path: '/settings/',
  getParentRoute: () => pharmaLayoutRoute,
} as any)

const pharmaLayoutSalesIndexRoute = pharmaLayoutSalesIndexImport.update({
  path: '/sales/',
  getParentRoute: () => pharmaLayoutRoute,
} as any)

const pharmaLayoutPatientsIndexRoute = pharmaLayoutPatientsIndexImport.update({
  path: '/patients/',
  getParentRoute: () => pharmaLayoutRoute,
} as any)

const pharmaLayoutOverviewIndexRoute = pharmaLayoutOverviewIndexImport.update({
  path: '/overview/',
  getParentRoute: () => pharmaLayoutRoute,
} as any)

const pharmaLayoutOffersIndexRoute = pharmaLayoutOffersIndexImport.update({
  path: '/offers/',
  getParentRoute: () => pharmaLayoutRoute,
} as any)

const pharmaLayoutInvoicingIndexRoute = pharmaLayoutInvoicingIndexImport.update(
  {
    path: '/invoicing/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any,
)

const pharmaLayoutInventoryIndexRoute = pharmaLayoutInventoryIndexImport.update(
  {
    path: '/inventory/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any,
)

const pharmaLayoutHomeIndexRoute = pharmaLayoutHomeIndexImport.update({
  path: '/home/',
  getParentRoute: () => pharmaLayoutRoute,
} as any)

const pharmaLayoutAccountsIndexRoute = pharmaLayoutAccountsIndexImport.update({
  path: '/accounts/',
  getParentRoute: () => pharmaLayoutRoute,
} as any)

const pharmaLayoutReceiptSaleIdRoute = pharmaLayoutReceiptSaleIdImport.update({
  path: '/receipt/$saleId',
  getParentRoute: () => pharmaLayoutRoute,
} as any)

const CompanyLayoutInventoryTransferStockIndexRoute =
  CompanyLayoutInventoryTransferStockIndexImport.update({
    path: '/inventory/transfer-stock/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any)

const CompanyLayoutInventoryTransferHistoryIndexRoute =
  CompanyLayoutInventoryTransferHistoryIndexImport.update({
    path: '/inventory/transfer-history/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any)

const CompanyLayoutInventoryPendingAcceptanceInventoryIndexRoute =
  CompanyLayoutInventoryPendingAcceptanceInventoryIndexImport.update({
    path: '/inventory/pending-acceptance-inventory/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any)

const CompanyLayoutInventoryNonMedicalMasterIndexRoute =
  CompanyLayoutInventoryNonMedicalMasterIndexImport.update({
    path: '/inventory/non-medical-master/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any)

const CompanyLayoutInventoryMedicalMasterIndexRoute =
  CompanyLayoutInventoryMedicalMasterIndexImport.update({
    path: '/inventory/medical-master/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any)

const CompanyLayoutInventoryAvailableInventoryIndexRoute =
  CompanyLayoutInventoryAvailableInventoryIndexImport.update({
    path: '/inventory/available-inventory/',
    getParentRoute: () => CompanyLayoutRoute,
  } as any)

const pharmaLayoutSuppliersSupplierIdIndexRoute =
  pharmaLayoutSuppliersSupplierIdIndexImport.update({
    path: '/suppliers/$supplierId/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsVoidSalesIndexRoute =
  pharmaLayoutReportsVoidSalesIndexImport.update({
    path: '/reports/void-sales/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsSupplierProfitabilityIndexRoute =
  pharmaLayoutReportsSupplierProfitabilityIndexImport.update({
    path: '/reports/supplier-profitability/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsShiftHistoryIndexRoute =
  pharmaLayoutReportsShiftHistoryIndexImport.update({
    path: '/reports/shift-history/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsSalesSummaryIndexRoute =
  pharmaLayoutReportsSalesSummaryIndexImport.update({
    path: '/reports/sales-summary/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsSalesPerItemIndexRoute =
  pharmaLayoutReportsSalesPerItemIndexImport.update({
    path: '/reports/sales-per-item/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsPurchaseReturnsListIndexRoute =
  pharmaLayoutReportsPurchaseReturnsListIndexImport.update({
    path: '/reports/purchase-returns-list/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsPurchaseRequestsListIndexRoute =
  pharmaLayoutReportsPurchaseRequestsListIndexImport.update({
    path: '/reports/purchase-requests-list/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsPurchaseOrderListIndexRoute =
  pharmaLayoutReportsPurchaseOrderListIndexImport.update({
    path: '/reports/purchase-order-list/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsPurchaseInvoiceListIndexRoute =
  pharmaLayoutReportsPurchaseInvoiceListIndexImport.update({
    path: '/reports/purchase-invoice-list/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsProductProfitablityIndexRoute =
  pharmaLayoutReportsProductProfitablityIndexImport.update({
    path: '/reports/product-profitablity/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsPlReportIndexRoute =
  pharmaLayoutReportsPlReportIndexImport.update({
    path: '/reports/pl-report/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsOutOfStockIndexRoute =
  pharmaLayoutReportsOutOfStockIndexImport.update({
    path: '/reports/out-of-stock/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsExpiryListIndexRoute =
  pharmaLayoutReportsExpiryListIndexImport.update({
    path: '/reports/expiry-list/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsCustomerWiseRevenueIndexRoute =
  pharmaLayoutReportsCustomerWiseRevenueIndexImport.update({
    path: '/reports/customer-wise-revenue/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutOverviewSaleshistoryIndexRoute =
  pharmaLayoutOverviewSaleshistoryIndexImport.update({
    path: '/overview/sales_history/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryTransferStockIndexRoute =
  pharmaLayoutInventoryTransferStockIndexImport.update({
    path: '/inventory/transfer-stock/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryTransferHistoryIndexRoute =
  pharmaLayoutInventoryTransferHistoryIndexImport.update({
    path: '/inventory/transfer-history/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryPendingAcceptanceInventoryIndexRoute =
  pharmaLayoutInventoryPendingAcceptanceInventoryIndexImport.update({
    path: '/inventory/pending-acceptance-inventory/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryNonMedicalMasterIndexRoute =
  pharmaLayoutInventoryNonMedicalMasterIndexImport.update({
    path: '/inventory/non-medical-master/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryMedicalMasterIndexRoute =
  pharmaLayoutInventoryMedicalMasterIndexImport.update({
    path: '/inventory/medical-master/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryCreatePurchaseOrderIndexRoute =
  pharmaLayoutInventoryCreatePurchaseOrderIndexImport.update({
    path: '/inventory/create-purchase-order/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryAvailableInventoryIndexRoute =
  pharmaLayoutInventoryAvailableInventoryIndexImport.update({
    path: '/inventory/available-inventory/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryAddStockIndexRoute =
  pharmaLayoutInventoryAddStockIndexImport.update({
    path: '/inventory/add-stock/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutAccountsRevenueIndexRoute =
  pharmaLayoutAccountsRevenueIndexImport.update({
    path: '/accounts/revenue/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutAccountsProfitLossIndexRoute =
  pharmaLayoutAccountsProfitLossIndexImport.update({
    path: '/accounts/profit-loss/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutAccountsPaymentMethodBreakdownIndexRoute =
  pharmaLayoutAccountsPaymentMethodBreakdownIndexImport.update({
    path: '/accounts/payment-method-breakdown/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutAccountsCostOfGoodsIndexRoute =
  pharmaLayoutAccountsCostOfGoodsIndexImport.update({
    path: '/accounts/cost-of-goods/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const inventoryBranchLayoutSettingsIndexRoute =
  inventoryBranchLayoutSettingsIndexImport.update({
    path: '/settings/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutSaleshistoryIndexRoute =
  inventoryBranchLayoutSaleshistoryIndexImport.update({
    path: '/sales_history/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsIndexRoute =
  inventoryBranchLayoutReportsIndexImport.update({
    path: '/reports/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutPurchaseOrdersIndexRoute =
  inventoryBranchLayoutPurchaseOrdersIndexImport.update({
    path: '/purchase-orders/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutPurchaseInvoicesIndexRoute =
  inventoryBranchLayoutPurchaseInvoicesIndexImport.update({
    path: '/purchase-invoices/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutInventoryIndexRoute =
  inventoryBranchLayoutInventoryIndexImport.update({
    path: '/inventory/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutDashboardIndexRoute =
  inventoryBranchLayoutDashboardIndexImport.update({
    path: '/dashboard/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutAutomationsIndexRoute =
  inventoryBranchLayoutAutomationsIndexImport.update({
    path: '/automations/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutAccountsIndexRoute =
  inventoryBranchLayoutAccountsIndexImport.update({
    path: '/accounts/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const pharmaLayoutSuppliersSupplierIdSupplierCreditNotesIndexRoute =
  pharmaLayoutSuppliersSupplierIdSupplierCreditNotesIndexImport.update({
    path: '/suppliers/$supplierId/supplier-credit-notes/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutSuppliersSupplierIdMakePaymentIndexRoute =
  pharmaLayoutSuppliersSupplierIdMakePaymentIndexImport.update({
    path: '/suppliers/$supplierId/make-payment/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutPatientsPatientInfoPatientIdIndexRoute =
  pharmaLayoutPatientsPatientInfoPatientIdIndexImport.update({
    path: '/patients/patient-info/$patientId/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutOverviewSaleshistorySaleIdIndexRoute =
  pharmaLayoutOverviewSaleshistorySaleIdIndexImport.update({
    path: '/overview/sales_history/$saleId/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryPurchaseRequestIdIndexRoute =
  pharmaLayoutInventoryPurchaseRequestIdIndexImport.update({
    path: '/inventory/purchase-request/$id/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryPurchaseOrderIdIndexRoute =
  pharmaLayoutInventoryPurchaseOrderIdIndexImport.update({
    path: '/inventory/purchase-order/$id/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryPurchaseInvoiceCreateIndexRoute =
  pharmaLayoutInventoryPurchaseInvoiceCreateIndexImport.update({
    path: '/inventory/purchase-invoice/create/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryPurchaseInvoiceIdIndexRoute =
  pharmaLayoutInventoryPurchaseInvoiceIdIndexImport.update({
    path: '/inventory/purchase-invoice/$id/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsSupplierProfitabilityIndexRoute =
  inventoryBranchLayoutReportsSupplierProfitabilityIndexImport.update({
    path: '/reports/supplier-profitability/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsSlowMovingItemsIndexRoute =
  inventoryBranchLayoutReportsSlowMovingItemsIndexImport.update({
    path: '/reports/slow-moving-items/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsShiftHistoryIndexRoute =
  inventoryBranchLayoutReportsShiftHistoryIndexImport.update({
    path: '/reports/shift-history/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsSalesSummaryIndexRoute =
  inventoryBranchLayoutReportsSalesSummaryIndexImport.update({
    path: '/reports/sales-summary/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsSalesPerItemIndexRoute =
  inventoryBranchLayoutReportsSalesPerItemIndexImport.update({
    path: '/reports/sales-per-item/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsProductProfitablityIndexRoute =
  inventoryBranchLayoutReportsProductProfitablityIndexImport.update({
    path: '/reports/product-profitablity/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsPlReportIndexRoute =
  inventoryBranchLayoutReportsPlReportIndexImport.update({
    path: '/reports/pl-report/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsOutOfStockIndexRoute =
  inventoryBranchLayoutReportsOutOfStockIndexImport.update({
    path: '/reports/out-of-stock/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsItemsReorderReportIndexRoute =
  inventoryBranchLayoutReportsItemsReorderReportIndexImport.update({
    path: '/reports/items-reorder-report/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsItemSalesVelocityIndexRoute =
  inventoryBranchLayoutReportsItemSalesVelocityIndexImport.update({
    path: '/reports/item-sales-velocity/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsFastMovingItemsIndexRoute =
  inventoryBranchLayoutReportsFastMovingItemsIndexImport.update({
    path: '/reports/fast-moving-items/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsExpiryListIndexRoute =
  inventoryBranchLayoutReportsExpiryListIndexImport.update({
    path: '/reports/expiry-list/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsCustomerWiseRevenueIndexRoute =
  inventoryBranchLayoutReportsCustomerWiseRevenueIndexImport.update({
    path: '/reports/customer-wise-revenue/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutPurchaseOrdersCreateIndexRoute =
  inventoryBranchLayoutPurchaseOrdersCreateIndexImport.update({
    path: '/purchase-orders/create/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutPurchaseOrdersIdIndexRoute =
  inventoryBranchLayoutPurchaseOrdersIdIndexImport.update({
    path: '/purchase-orders/$id/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutPurchaseInvoicesCreateIndexRoute =
  inventoryBranchLayoutPurchaseInvoicesCreateIndexImport.update({
    path: '/purchase-invoices/create/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutPurchaseInvoicesIdIndexRoute =
  inventoryBranchLayoutPurchaseInvoicesIdIndexImport.update({
    path: '/purchase-invoices/$id/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutInventoryTransferStockIndexRoute =
  inventoryBranchLayoutInventoryTransferStockIndexImport.update({
    path: '/inventory/transfer-stock/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutInventoryTransferHistoryIndexRoute =
  inventoryBranchLayoutInventoryTransferHistoryIndexImport.update({
    path: '/inventory/transfer-history/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutInventoryPendingAcceptanceInventoryIndexRoute =
  inventoryBranchLayoutInventoryPendingAcceptanceInventoryIndexImport.update({
    path: '/inventory/pending-acceptance-inventory/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutInventoryNonMedicalMasterIndexRoute =
  inventoryBranchLayoutInventoryNonMedicalMasterIndexImport.update({
    path: '/inventory/non-medical-master/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutInventoryMedicalMasterIndexRoute =
  inventoryBranchLayoutInventoryMedicalMasterIndexImport.update({
    path: '/inventory/medical-master/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutInventoryAvailableInventoryIndexRoute =
  inventoryBranchLayoutInventoryAvailableInventoryIndexImport.update({
    path: '/inventory/available-inventory/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutAutomationsIdIndexRoute =
  inventoryBranchLayoutAutomationsIdIndexImport.update({
    path: '/automations/$id/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutAccountsRevenueIndexRoute =
  inventoryBranchLayoutAccountsRevenueIndexImport.update({
    path: '/accounts/revenue/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutAccountsProfitLossIndexRoute =
  inventoryBranchLayoutAccountsProfitLossIndexImport.update({
    path: '/accounts/profit-loss/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutAccountsPaymentMethodBreakdownIndexRoute =
  inventoryBranchLayoutAccountsPaymentMethodBreakdownIndexImport.update({
    path: '/accounts/payment-method-breakdown/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutAccountsCostOfGoodsIndexRoute =
  inventoryBranchLayoutAccountsCostOfGoodsIndexImport.update({
    path: '/accounts/cost-of-goods/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const CompanyLayoutInventoryItemTypeItemIdRoute =
  CompanyLayoutInventoryItemTypeItemIdImport.update({
    path: '/inventory/item/$type/$itemId',
    getParentRoute: () => CompanyLayoutRoute,
  } as any)

const pharmaLayoutInventoryItemTypeItemIdRoute =
  pharmaLayoutInventoryItemTypeItemIdImport.update({
    path: '/inventory/item/$type/$itemId',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutReportsShiftHistoryShiftSummaryShiftIdIndexRoute =
  pharmaLayoutReportsShiftHistoryShiftSummaryShiftIdIndexImport.update({
    path: '/reports/shift-history/shift-summary/$shiftId/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const pharmaLayoutInventoryPurchaseInvoiceIdPdfIndexRoute =
  pharmaLayoutInventoryPurchaseInvoiceIdPdfIndexImport.update({
    path: '/inventory/purchase-invoice/$id/pdf/',
    getParentRoute: () => pharmaLayoutRoute,
  } as any)

const inventoryBranchLayoutPurchaseInvoicesIdPdfIndexRoute =
  inventoryBranchLayoutPurchaseInvoicesIdPdfIndexImport.update({
    path: '/purchase-invoices/$id/pdf/',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutInventoryItemTypeItemIdRoute =
  inventoryBranchLayoutInventoryItemTypeItemIdImport.update({
    path: '/inventory/item/$type/$itemId',
    getParentRoute: () => inventoryBranchLayoutRoute,
  } as any)

const inventoryBranchLayoutReportsShiftHistoryShiftSummaryShiftIdIndexRoute =
  inventoryBranchLayoutReportsShiftHistoryShiftSummaryShiftIdIndexImport.update(
    {
      path: '/reports/shift-history/shift-summary/$shiftId/',
      getParentRoute: () => inventoryBranchLayoutRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(pharma)': {
      preLoaderRoute: typeof pharmaImport
      parentRoute: typeof rootRoute
    }
    '/(pharma)/_layout': {
      preLoaderRoute: typeof pharmaLayoutImport
      parentRoute: typeof pharmaRoute
    }
    '/company': {
      preLoaderRoute: typeof CompanyImport
      parentRoute: typeof rootRoute
    }
    '/company/_layout': {
      preLoaderRoute: typeof CompanyLayoutImport
      parentRoute: typeof CompanyRoute
    }
    '/company/': {
      preLoaderRoute: typeof CompanyIndexImport
      parentRoute: typeof CompanyImport
    }
    '/pdf2/': {
      preLoaderRoute: typeof Pdf2IndexImport
      parentRoute: typeof rootRoute
    }
    '/(inventory)/branch': {
      preLoaderRoute: typeof inventoryBranchImport
      parentRoute: typeof rootRoute
    }
    '/(inventory)/branch/_layout': {
      preLoaderRoute: typeof inventoryBranchLayoutImport
      parentRoute: typeof inventoryBranchRoute
    }
    '/(auth)/forgot-password/': {
      preLoaderRoute: typeof authForgotPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/login/': {
      preLoaderRoute: typeof authLoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/reset-password/': {
      preLoaderRoute: typeof authResetPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/select-access/': {
      preLoaderRoute: typeof authSelectAccessIndexImport
      parentRoute: typeof rootRoute
    }
    '/(inventory)/branch/': {
      preLoaderRoute: typeof inventoryBranchIndexImport
      parentRoute: typeof inventoryBranchImport
    }
    '/(pharma)/_layout/receipt/$saleId': {
      preLoaderRoute: typeof pharmaLayoutReceiptSaleIdImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/accounts/': {
      preLoaderRoute: typeof pharmaLayoutAccountsIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/home/': {
      preLoaderRoute: typeof pharmaLayoutHomeIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/': {
      preLoaderRoute: typeof pharmaLayoutInventoryIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/invoicing/': {
      preLoaderRoute: typeof pharmaLayoutInvoicingIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/offers/': {
      preLoaderRoute: typeof pharmaLayoutOffersIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/overview/': {
      preLoaderRoute: typeof pharmaLayoutOverviewIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/patients/': {
      preLoaderRoute: typeof pharmaLayoutPatientsIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/sales/': {
      preLoaderRoute: typeof pharmaLayoutSalesIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/settings/': {
      preLoaderRoute: typeof pharmaLayoutSettingsIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/stock-taking/': {
      preLoaderRoute: typeof pharmaLayoutStockTakingIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/suppliers/': {
      preLoaderRoute: typeof pharmaLayoutSuppliersIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/company/_layout/accounts/': {
      preLoaderRoute: typeof CompanyLayoutAccountsIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/dashboard/': {
      preLoaderRoute: typeof CompanyLayoutDashboardIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/home/': {
      preLoaderRoute: typeof CompanyLayoutHomeIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/inventory/': {
      preLoaderRoute: typeof CompanyLayoutInventoryIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/reports/': {
      preLoaderRoute: typeof CompanyLayoutReportsIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/settings/': {
      preLoaderRoute: typeof CompanyLayoutSettingsIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/(inventory)/branch/_layout/accounts/': {
      preLoaderRoute: typeof inventoryBranchLayoutAccountsIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/automations/': {
      preLoaderRoute: typeof inventoryBranchLayoutAutomationsIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/dashboard/': {
      preLoaderRoute: typeof inventoryBranchLayoutDashboardIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/inventory/': {
      preLoaderRoute: typeof inventoryBranchLayoutInventoryIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/purchase-invoices/': {
      preLoaderRoute: typeof inventoryBranchLayoutPurchaseInvoicesIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/purchase-orders/': {
      preLoaderRoute: typeof inventoryBranchLayoutPurchaseOrdersIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/sales_history/': {
      preLoaderRoute: typeof inventoryBranchLayoutSaleshistoryIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/settings/': {
      preLoaderRoute: typeof inventoryBranchLayoutSettingsIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(pharma)/_layout/accounts/cost-of-goods/': {
      preLoaderRoute: typeof pharmaLayoutAccountsCostOfGoodsIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/accounts/payment-method-breakdown/': {
      preLoaderRoute: typeof pharmaLayoutAccountsPaymentMethodBreakdownIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/accounts/profit-loss/': {
      preLoaderRoute: typeof pharmaLayoutAccountsProfitLossIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/accounts/revenue/': {
      preLoaderRoute: typeof pharmaLayoutAccountsRevenueIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/add-stock/': {
      preLoaderRoute: typeof pharmaLayoutInventoryAddStockIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/available-inventory/': {
      preLoaderRoute: typeof pharmaLayoutInventoryAvailableInventoryIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/create-purchase-order/': {
      preLoaderRoute: typeof pharmaLayoutInventoryCreatePurchaseOrderIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/medical-master/': {
      preLoaderRoute: typeof pharmaLayoutInventoryMedicalMasterIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/non-medical-master/': {
      preLoaderRoute: typeof pharmaLayoutInventoryNonMedicalMasterIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/pending-acceptance-inventory/': {
      preLoaderRoute: typeof pharmaLayoutInventoryPendingAcceptanceInventoryIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/transfer-history/': {
      preLoaderRoute: typeof pharmaLayoutInventoryTransferHistoryIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/transfer-stock/': {
      preLoaderRoute: typeof pharmaLayoutInventoryTransferStockIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/overview/sales_history/': {
      preLoaderRoute: typeof pharmaLayoutOverviewSaleshistoryIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/customer-wise-revenue/': {
      preLoaderRoute: typeof pharmaLayoutReportsCustomerWiseRevenueIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/expiry-list/': {
      preLoaderRoute: typeof pharmaLayoutReportsExpiryListIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/out-of-stock/': {
      preLoaderRoute: typeof pharmaLayoutReportsOutOfStockIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/pl-report/': {
      preLoaderRoute: typeof pharmaLayoutReportsPlReportIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/product-profitablity/': {
      preLoaderRoute: typeof pharmaLayoutReportsProductProfitablityIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/purchase-invoice-list/': {
      preLoaderRoute: typeof pharmaLayoutReportsPurchaseInvoiceListIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/purchase-order-list/': {
      preLoaderRoute: typeof pharmaLayoutReportsPurchaseOrderListIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/purchase-requests-list/': {
      preLoaderRoute: typeof pharmaLayoutReportsPurchaseRequestsListIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/purchase-returns-list/': {
      preLoaderRoute: typeof pharmaLayoutReportsPurchaseReturnsListIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/sales-per-item/': {
      preLoaderRoute: typeof pharmaLayoutReportsSalesPerItemIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/sales-summary/': {
      preLoaderRoute: typeof pharmaLayoutReportsSalesSummaryIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/shift-history/': {
      preLoaderRoute: typeof pharmaLayoutReportsShiftHistoryIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/supplier-profitability/': {
      preLoaderRoute: typeof pharmaLayoutReportsSupplierProfitabilityIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/void-sales/': {
      preLoaderRoute: typeof pharmaLayoutReportsVoidSalesIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/suppliers/$supplierId/': {
      preLoaderRoute: typeof pharmaLayoutSuppliersSupplierIdIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/company/_layout/inventory/available-inventory/': {
      preLoaderRoute: typeof CompanyLayoutInventoryAvailableInventoryIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/inventory/medical-master/': {
      preLoaderRoute: typeof CompanyLayoutInventoryMedicalMasterIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/inventory/non-medical-master/': {
      preLoaderRoute: typeof CompanyLayoutInventoryNonMedicalMasterIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/inventory/pending-acceptance-inventory/': {
      preLoaderRoute: typeof CompanyLayoutInventoryPendingAcceptanceInventoryIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/inventory/transfer-history/': {
      preLoaderRoute: typeof CompanyLayoutInventoryTransferHistoryIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/company/_layout/inventory/transfer-stock/': {
      preLoaderRoute: typeof CompanyLayoutInventoryTransferStockIndexImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/(pharma)/_layout/inventory/item/$type/$itemId': {
      preLoaderRoute: typeof pharmaLayoutInventoryItemTypeItemIdImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/company/_layout/inventory/item/$type/$itemId': {
      preLoaderRoute: typeof CompanyLayoutInventoryItemTypeItemIdImport
      parentRoute: typeof CompanyLayoutImport
    }
    '/(inventory)/branch/_layout/accounts/cost-of-goods/': {
      preLoaderRoute: typeof inventoryBranchLayoutAccountsCostOfGoodsIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/accounts/payment-method-breakdown/': {
      preLoaderRoute: typeof inventoryBranchLayoutAccountsPaymentMethodBreakdownIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/accounts/profit-loss/': {
      preLoaderRoute: typeof inventoryBranchLayoutAccountsProfitLossIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/accounts/revenue/': {
      preLoaderRoute: typeof inventoryBranchLayoutAccountsRevenueIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/automations/$id/': {
      preLoaderRoute: typeof inventoryBranchLayoutAutomationsIdIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/inventory/available-inventory/': {
      preLoaderRoute: typeof inventoryBranchLayoutInventoryAvailableInventoryIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/inventory/medical-master/': {
      preLoaderRoute: typeof inventoryBranchLayoutInventoryMedicalMasterIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/inventory/non-medical-master/': {
      preLoaderRoute: typeof inventoryBranchLayoutInventoryNonMedicalMasterIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/inventory/pending-acceptance-inventory/': {
      preLoaderRoute: typeof inventoryBranchLayoutInventoryPendingAcceptanceInventoryIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/inventory/transfer-history/': {
      preLoaderRoute: typeof inventoryBranchLayoutInventoryTransferHistoryIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/inventory/transfer-stock/': {
      preLoaderRoute: typeof inventoryBranchLayoutInventoryTransferStockIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/purchase-invoices/$id/': {
      preLoaderRoute: typeof inventoryBranchLayoutPurchaseInvoicesIdIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/purchase-invoices/create/': {
      preLoaderRoute: typeof inventoryBranchLayoutPurchaseInvoicesCreateIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/purchase-orders/$id/': {
      preLoaderRoute: typeof inventoryBranchLayoutPurchaseOrdersIdIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/purchase-orders/create/': {
      preLoaderRoute: typeof inventoryBranchLayoutPurchaseOrdersCreateIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/customer-wise-revenue/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsCustomerWiseRevenueIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/expiry-list/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsExpiryListIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/fast-moving-items/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsFastMovingItemsIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/item-sales-velocity/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsItemSalesVelocityIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/items-reorder-report/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsItemsReorderReportIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/out-of-stock/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsOutOfStockIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/pl-report/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsPlReportIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/product-profitablity/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsProductProfitablityIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/sales-per-item/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsSalesPerItemIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/sales-summary/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsSalesSummaryIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/shift-history/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsShiftHistoryIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/slow-moving-items/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsSlowMovingItemsIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/reports/supplier-profitability/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsSupplierProfitabilityIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(pharma)/_layout/inventory/purchase-invoice/$id/': {
      preLoaderRoute: typeof pharmaLayoutInventoryPurchaseInvoiceIdIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/purchase-invoice/create/': {
      preLoaderRoute: typeof pharmaLayoutInventoryPurchaseInvoiceCreateIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/purchase-order/$id/': {
      preLoaderRoute: typeof pharmaLayoutInventoryPurchaseOrderIdIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/inventory/purchase-request/$id/': {
      preLoaderRoute: typeof pharmaLayoutInventoryPurchaseRequestIdIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/overview/sales_history/$saleId/': {
      preLoaderRoute: typeof pharmaLayoutOverviewSaleshistorySaleIdIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/patients/patient-info/$patientId/': {
      preLoaderRoute: typeof pharmaLayoutPatientsPatientInfoPatientIdIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/suppliers/$supplierId/make-payment/': {
      preLoaderRoute: typeof pharmaLayoutSuppliersSupplierIdMakePaymentIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/suppliers/$supplierId/supplier-credit-notes/': {
      preLoaderRoute: typeof pharmaLayoutSuppliersSupplierIdSupplierCreditNotesIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(inventory)/branch/_layout/inventory/item/$type/$itemId': {
      preLoaderRoute: typeof inventoryBranchLayoutInventoryItemTypeItemIdImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(inventory)/branch/_layout/purchase-invoices/$id/pdf/': {
      preLoaderRoute: typeof inventoryBranchLayoutPurchaseInvoicesIdPdfIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
    '/(pharma)/_layout/inventory/purchase-invoice/$id/pdf/': {
      preLoaderRoute: typeof pharmaLayoutInventoryPurchaseInvoiceIdPdfIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(pharma)/_layout/reports/shift-history/shift-summary/$shiftId/': {
      preLoaderRoute: typeof pharmaLayoutReportsShiftHistoryShiftSummaryShiftIdIndexImport
      parentRoute: typeof pharmaLayoutImport
    }
    '/(inventory)/branch/_layout/reports/shift-history/shift-summary/$shiftId/': {
      preLoaderRoute: typeof inventoryBranchLayoutReportsShiftHistoryShiftSummaryShiftIdIndexImport
      parentRoute: typeof inventoryBranchLayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  pharmaRoute.addChildren([
    pharmaLayoutRoute.addChildren([
      pharmaLayoutReceiptSaleIdRoute,
      pharmaLayoutAccountsIndexRoute,
      pharmaLayoutHomeIndexRoute,
      pharmaLayoutInventoryIndexRoute,
      pharmaLayoutInvoicingIndexRoute,
      pharmaLayoutOffersIndexRoute,
      pharmaLayoutOverviewIndexRoute,
      pharmaLayoutPatientsIndexRoute,
      pharmaLayoutSalesIndexRoute,
      pharmaLayoutSettingsIndexRoute,
      pharmaLayoutStockTakingIndexRoute,
      pharmaLayoutSuppliersIndexRoute,
      pharmaLayoutAccountsCostOfGoodsIndexRoute,
      pharmaLayoutAccountsPaymentMethodBreakdownIndexRoute,
      pharmaLayoutAccountsProfitLossIndexRoute,
      pharmaLayoutAccountsRevenueIndexRoute,
      pharmaLayoutInventoryAddStockIndexRoute,
      pharmaLayoutInventoryAvailableInventoryIndexRoute,
      pharmaLayoutInventoryCreatePurchaseOrderIndexRoute,
      pharmaLayoutInventoryMedicalMasterIndexRoute,
      pharmaLayoutInventoryNonMedicalMasterIndexRoute,
      pharmaLayoutInventoryPendingAcceptanceInventoryIndexRoute,
      pharmaLayoutInventoryTransferHistoryIndexRoute,
      pharmaLayoutInventoryTransferStockIndexRoute,
      pharmaLayoutOverviewSaleshistoryIndexRoute,
      pharmaLayoutReportsCustomerWiseRevenueIndexRoute,
      pharmaLayoutReportsExpiryListIndexRoute,
      pharmaLayoutReportsOutOfStockIndexRoute,
      pharmaLayoutReportsPlReportIndexRoute,
      pharmaLayoutReportsProductProfitablityIndexRoute,
      pharmaLayoutReportsPurchaseInvoiceListIndexRoute,
      pharmaLayoutReportsPurchaseOrderListIndexRoute,
      pharmaLayoutReportsPurchaseRequestsListIndexRoute,
      pharmaLayoutReportsPurchaseReturnsListIndexRoute,
      pharmaLayoutReportsSalesPerItemIndexRoute,
      pharmaLayoutReportsSalesSummaryIndexRoute,
      pharmaLayoutReportsShiftHistoryIndexRoute,
      pharmaLayoutReportsSupplierProfitabilityIndexRoute,
      pharmaLayoutReportsVoidSalesIndexRoute,
      pharmaLayoutSuppliersSupplierIdIndexRoute,
      pharmaLayoutInventoryItemTypeItemIdRoute,
      pharmaLayoutInventoryPurchaseInvoiceIdIndexRoute,
      pharmaLayoutInventoryPurchaseInvoiceCreateIndexRoute,
      pharmaLayoutInventoryPurchaseOrderIdIndexRoute,
      pharmaLayoutInventoryPurchaseRequestIdIndexRoute,
      pharmaLayoutOverviewSaleshistorySaleIdIndexRoute,
      pharmaLayoutPatientsPatientInfoPatientIdIndexRoute,
      pharmaLayoutSuppliersSupplierIdMakePaymentIndexRoute,
      pharmaLayoutSuppliersSupplierIdSupplierCreditNotesIndexRoute,
      pharmaLayoutInventoryPurchaseInvoiceIdPdfIndexRoute,
      pharmaLayoutReportsShiftHistoryShiftSummaryShiftIdIndexRoute,
    ]),
  ]),
  CompanyRoute.addChildren([
    CompanyLayoutRoute.addChildren([
      CompanyLayoutAccountsIndexRoute,
      CompanyLayoutDashboardIndexRoute,
      CompanyLayoutHomeIndexRoute,
      CompanyLayoutInventoryIndexRoute,
      CompanyLayoutReportsIndexRoute,
      CompanyLayoutSettingsIndexRoute,
      CompanyLayoutInventoryAvailableInventoryIndexRoute,
      CompanyLayoutInventoryMedicalMasterIndexRoute,
      CompanyLayoutInventoryNonMedicalMasterIndexRoute,
      CompanyLayoutInventoryPendingAcceptanceInventoryIndexRoute,
      CompanyLayoutInventoryTransferHistoryIndexRoute,
      CompanyLayoutInventoryTransferStockIndexRoute,
      CompanyLayoutInventoryItemTypeItemIdRoute,
    ]),
    CompanyIndexRoute,
  ]),
  Pdf2IndexRoute,
  inventoryBranchRoute.addChildren([
    inventoryBranchLayoutRoute.addChildren([
      inventoryBranchLayoutAccountsIndexRoute,
      inventoryBranchLayoutAutomationsIndexRoute,
      inventoryBranchLayoutDashboardIndexRoute,
      inventoryBranchLayoutInventoryIndexRoute,
      inventoryBranchLayoutPurchaseInvoicesIndexRoute,
      inventoryBranchLayoutPurchaseOrdersIndexRoute,
      inventoryBranchLayoutReportsIndexRoute,
      inventoryBranchLayoutSaleshistoryIndexRoute,
      inventoryBranchLayoutSettingsIndexRoute,
      inventoryBranchLayoutAccountsCostOfGoodsIndexRoute,
      inventoryBranchLayoutAccountsPaymentMethodBreakdownIndexRoute,
      inventoryBranchLayoutAccountsProfitLossIndexRoute,
      inventoryBranchLayoutAccountsRevenueIndexRoute,
      inventoryBranchLayoutAutomationsIdIndexRoute,
      inventoryBranchLayoutInventoryAvailableInventoryIndexRoute,
      inventoryBranchLayoutInventoryMedicalMasterIndexRoute,
      inventoryBranchLayoutInventoryNonMedicalMasterIndexRoute,
      inventoryBranchLayoutInventoryPendingAcceptanceInventoryIndexRoute,
      inventoryBranchLayoutInventoryTransferHistoryIndexRoute,
      inventoryBranchLayoutInventoryTransferStockIndexRoute,
      inventoryBranchLayoutPurchaseInvoicesIdIndexRoute,
      inventoryBranchLayoutPurchaseInvoicesCreateIndexRoute,
      inventoryBranchLayoutPurchaseOrdersIdIndexRoute,
      inventoryBranchLayoutPurchaseOrdersCreateIndexRoute,
      inventoryBranchLayoutReportsCustomerWiseRevenueIndexRoute,
      inventoryBranchLayoutReportsExpiryListIndexRoute,
      inventoryBranchLayoutReportsFastMovingItemsIndexRoute,
      inventoryBranchLayoutReportsItemSalesVelocityIndexRoute,
      inventoryBranchLayoutReportsItemsReorderReportIndexRoute,
      inventoryBranchLayoutReportsOutOfStockIndexRoute,
      inventoryBranchLayoutReportsPlReportIndexRoute,
      inventoryBranchLayoutReportsProductProfitablityIndexRoute,
      inventoryBranchLayoutReportsSalesPerItemIndexRoute,
      inventoryBranchLayoutReportsSalesSummaryIndexRoute,
      inventoryBranchLayoutReportsShiftHistoryIndexRoute,
      inventoryBranchLayoutReportsSlowMovingItemsIndexRoute,
      inventoryBranchLayoutReportsSupplierProfitabilityIndexRoute,
      inventoryBranchLayoutInventoryItemTypeItemIdRoute,
      inventoryBranchLayoutPurchaseInvoicesIdPdfIndexRoute,
      inventoryBranchLayoutReportsShiftHistoryShiftSummaryShiftIdIndexRoute,
    ]),
    inventoryBranchIndexRoute,
  ]),
  authForgotPasswordIndexRoute,
  authLoginIndexRoute,
  authResetPasswordIndexRoute,
  authSelectAccessIndexRoute,
])

/* prettier-ignore-end */
